import { render } from "./SubmitProperty.vue?vue&type=template&id=137fa871"
import script from "./SubmitProperty.vue?vue&type=script&lang=js"
export * from "./SubmitProperty.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/webmobtuts/realestateapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__